// extracted by mini-css-extract-plugin
module.exports = {"root":"Integration_root__kdVNk"};